import * as joint from "@clientio/rappid";
import { PreferenceStore } from "../preference-store";
import vuetify from "../../../../plugins/vuetify";
import RappidContext from "../../rappid/rappid-context";

export default class UserInterface {
  constructor(private rappidContext: RappidContext) {}
  public init() {
    PreferenceStore.INSTANCE.on("change:gridEnabled", () => this.enableGrid());
    PreferenceStore.INSTANCE.on("change:gridShow", () => this.showGrid());
    PreferenceStore.INSTANCE.on("change:gridSize", () => this.updateGridSize());
    PreferenceStore.INSTANCE.on("change:isDark", () => this.switchTheme());
    PreferenceStore.INSTANCE.on("change:isReadOnly", () => this.switchInteractivity());
  }

  enableGrid() {
    if (PreferenceStore.INSTANCE.gridEnabled) {
      this.rappidContext.paper.setGridSize(PreferenceStore.INSTANCE.gridSize);
    } else {
      this.rappidContext.paper.setGridSize(-1);
      PreferenceStore.INSTANCE.gridShow = false;
    }
  }

  showGrid() {
    if (PreferenceStore.INSTANCE.gridShow) {
      this.rappidContext.paper.setGrid("mesh");
    } else {
      this.rappidContext.paper.setGrid(null);
    }
  }

  updateGridSize() {
    if (PreferenceStore.INSTANCE.gridShow) {
      this.rappidContext.paper.setGridSize(PreferenceStore.INSTANCE.gridSize);
      this.rappidContext.paper.setGrid("mesh");
    }
  }

  switchTheme() {
    PreferenceStore.INSTANCE.isDark
      ? PreferenceStore.INSTANCE.enableDarkTheme()
      : PreferenceStore.INSTANCE.enableLightTheme();
    vuetify.theme.global.name.value = PreferenceStore.INSTANCE.isDark ? "dark" : "light";

    this.rappidContext.commandManager.stopListening();
    joint.setTheme(PreferenceStore.INSTANCE.isDark ? "dark" : "default");
    this.rappidContext.paper?.updateViews();
    this.rappidContext.commandManager.listen();
  }

  switchInteractivity() {
    this.rappidContext.paper.setInteractivity(!PreferenceStore.INSTANCE.isReadOnly);
  }
}
